import { OrderModel } from "api";
import { JSONSchemaType } from "ajv";

export type OrderUpdateProperties = Pick<
  OrderModel,
  | "ShipToCode"
  | "NumAtCard"
  | "CardCode" /* These are the only valid inputs at this time. */
>;

export const orderPatchSchema: JSONSchemaType<OrderUpdateProperties> = {
  type: "object",
  properties: {
    ShipToCode: { type: "string", nullable: true },
    NumAtCard: { type: "string", nullable: true, maxLength: 100 },
    CardCode: { type: "string", nullable: true },
  },
  additionalProperties: false,
};
